import React, { useState, useEffect } from "react";
import { createGlobalStyle } from "styled-components";

import { createCalendar } from "./helpers";
//import Hatch from "./Hatch";
import styled from "styled-components";
import hatchBackdrop from "./img/hatch_backdrop.jpg";

const GlobalStyle = createGlobalStyle`
  body {
    background: center / cover url("./img/calendar_backdrop.jpg");
    margin: 0;
  }
`;

export const StyledApp = styled.div`
  display: grid;
  grid-gap: 15px;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));;
  padding: 15px;
`;

const StyledHatch = styled.div`
  padding-top: 100%; /* padding-top is based on the width - believe it or not!!! */
  position: relative;
  cursor: pointer;
  .front {
    background: center / cover url(${props => props.frontBackground});
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    p {
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: "Dancing Script", cursive;
      color: #8B0000;
      padding: 20px;
      width: 50%;
      height: 50%;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.7);
      font-weight: 700;
      font-size: 4rem;
    }
    &.open {
      transform: rotateY(180deg);
    }
  }
  .back {
    position: absolute;
    background: center / cover url(${props => props.backBackground});
    top: 0px;
    left: 0px;
    z-index: 1;
    transform: rotateY(180deg);
    p {
      font-family: "Dancing Script", cursive;
      color: #fff;
      padding: 10px;
      font-size: 1.4rem;
      text-align: center;
    }
    &.open {
      z-index: 2;
      transform: rotateY(0deg);
    }
  }
  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    transition: all 0.5s;
    transform-style: preserve-3d;
    border-radius: 20px;
    border: 1px solid #fff;
    box-sizing: border-box;
  }
`;

const Hatch = ({ hatchData: { id, nr, text, img, img2, open }, handleClick }) => (
  <StyledHatch frontBackground={"./img/" + nr + ".jpg"} backBackground={"./img/b" + nr + ".jpg"} /*onClick={() => handleClick(id)}*/>
    <div className={open || true ? "front open" : "front"}>
      <p>{nr}</p>
    </div>
    <div className={open || true ? "back open" : "back"}>
      <p></p>
    </div>
  </StyledHatch>
);

function ChristmaskCalendar() {
  const [hatches, setHatches] = useState([]);

  useEffect(() => {
    //THIS LINE WILL CLEAR THE HISTORY - needed after changes to helpers.js NOT NEEDED - we just load b1, b2, b3...
    //localStorage.removeItem("calendar");

    // Could use if statements instead off course
    const calendar = localStorage.calendar
      ? JSON.parse(localStorage.calendar)
      : createCalendar();

    setHatches(calendar);
  }, []);

  // Store calendar in localStorage
  useEffect(() => {
    // Could use if statements instead off course
    hatches.length && localStorage.setItem("calendar", JSON.stringify(hatches));
  }, [hatches]);

  const handleFlipHatch = id => {
    const d = new Date();
    const updatedHatches = hatches.map(hatch =>
//      (hatch.id === id && hatch.nr <= d.getDate()) ? { ...hatch, open: !hatch.open } : hatch
      (hatch.id === id) ? { ...hatch, open: !hatch.open } : hatch
    );
    setHatches(updatedHatches);
  };

  return (
    <>
      <GlobalStyle />
      <StyledApp>
        {hatches.map(hatch => (
          <Hatch
            key={hatch.id}
            hatchData={hatch}
            handleClick={handleFlipHatch}
          />
        ))}
      </StyledApp>
    </>
  );
}

export default ChristmaskCalendar;